import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService extends ApiService {

  // public url: string = 'https://onlinestore-api.laoapps.com/api/v1/';
  public url: string = 'https://hangmistore-api.laoapps.com/api/v1/';
  // public url: string = 'http://localhost:22200/api/v1/'


  public url_onlinestore: string = this.getBaseUrl();

  register(param: any): Observable<any> {

    return this.http.post(this.url + 'authUM/register', param);
  }
  login(param: any): Observable<any> {

    return this.http.post(this.url + 'authUM/login', param);
  }
  validatetoken(param: any): Observable<any> {

    return this.http.post(this.url_onlinestore + 'authUM/validatetoken', param);
  }
  deleteAccount(param: any): Observable<any> {

    return this.http.post(this.url_onlinestore + 'authUM/deleteAccount', param);
  }


  loggedIn() {
    return !!localStorage.getItem('token')
  }


  // =================== LAAB API ==================
  public url_laab:string = 'https://laab-api.laoapps.com/api/v1/'
  // public url_laab: string = 'http://192.168.2.106:30000/api/v1/'

  checkwallet(param: any): Observable<any> {
    return this.http.post(this.url_laab + 'laoapps_ewallet/user/find_my_wallet', param);
  }
  genwallet(param: any): Observable<any> {
    return this.http.post(this.url_laab + 'laoapps_ewallet/user/register_only_wallet', param);
  }
  showmywallet(param: any): Observable<any> {
    return this.http.post(this.url_laab + 'laoapps_ewallet/wallet/show_balance', param);
  }
  transferLaab(param: any): Observable<any> {
    return this.http.post(this.url_laab + 'laoapps_ewallet/wallet/expend', param);
  }
}
